import { FC, Fragment, memo } from "react";
import { FormikHandlers } from "formik";
import {
  AutocompleteFilterBody,
  AutocompleteFilterBodyProps,
} from "../AutocompleteFilterBody";
import {
  FilterItem,
  Operator,
  ResourceType,
  useGetUsersMeAccountsResourceTypesByResourceTypeInstanceTypesQuery,
} from "../../../../../../../../services/cloudchipr.api";
import { FilterItemOperatorType } from "../../../FilterItemOperatorType";

export type InstanceTypeFilterResourceType = "ec2" | "vm" | "az_vm";

interface InstanceTypeFilterProps extends AutocompleteFilterBodyProps {
  accountIds?: string[];
  resourceType: ResourceType;
  filter: FilterItem;
  operators?: Operator[];
  onChange: FormikHandlers["handleChange"];
}

export const InstanceTypeFilter: FC<InstanceTypeFilterProps> = memo(
  ({ resourceType, accountIds, operators, filter, onChange, ...props }) => {
    const { data, isLoading } =
      useGetUsersMeAccountsResourceTypesByResourceTypeInstanceTypesQuery({
        resourceType: resourceType as InstanceTypeFilterResourceType,
        // @ts-expect-error  //todo: this should be optional
        accountIds: accountIds?.length ? accountIds.join(",") : undefined,
      });

    return (
      <Fragment>
        <FilterItemOperatorType
          onChange={onChange}
          options={operators}
          value={filter.operator || "in"}
        />

        <AutocompleteFilterBody
          {...props}
          options={data ?? []}
          isLoading={isLoading}
          label="Instance Type"
          selectedValue={Array.isArray(filter?.value) ? filter.value : []}
        />
      </Fragment>
    );
  },
);
